import React from 'react';

import Hero from 'src/containers/TerapiRegeneratif/Hero';

import FAQ from './FAQ';
import MoreInformation from './MoreInformation';
import TerapiType from './TerapiType';
import VideoStemcell from './VideoStemcell';

import classes from './index.module.less';

const StemCell = () => {
	return (
		<div className={classes['stem-cell-page']}>
			<Hero
				title="Terapi Stem Cell di Indonesia:
				Inovasi Kesehatan untuk Penyakit Berat"
				description="Terapi pengobatan Stem Cell di Indonesia menjadi suatu terobosan yang
				berpotensi menyembuhkan berbagai penyakit berat, seperti penyakit kronis,
				penyakit degeneratif, dan penyakit autoimun. Saat ini penelitian tentang Stem Cell
				di Indonesia secara intensif dan komprehensif terus dilakukan demi mendapatkan
				potensi terbaik."
				image="/images/stem-cell/cells-model.png"
			/>
			<VideoStemcell />
			<MoreInformation />
			<TerapiType />
			<FAQ />
		</div>
	);
};

export default StemCell;
